import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";

// import css
import "./BusinessOneBitAbout.scss";

const BusinessOneBitAbout = () => {
  const { document: organisationDocument } = useDocument("settings", "organisation");

  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsActive((prev) => !prev);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className={`business_one_bit_about ${isActive ? "fivesec" : ""}`}>
      <div className="container">
        <div className="ba_inner">
          {/* ✅ Fixed ABOUT US spacing
          <h3 className="light_top_title">ABOUT US</h3> */}

          <div className="row align-items-center">
            {/* Left side (images) */}
            <div className="col-md-7">
              <div className="about_left">
                <div className="img_container">
                  <img className="img1" src="/assets/img/business/businessone/home/aboutimg1.jpg" alt="" />
                  <img className="img2" src="/assets/img/business/businessone/home/aboutimg2.jpg" alt="" />
                </div>
                <div className="img_container">
                  <img className="img3" src="/assets/img/business/businessone/home/aboutimg3.jpg" alt="" />
                  <img className="img4" src="/assets/img/business/businessone/home/aboutimg4.jpg" alt="" />
                </div>
              </div>
            </div>

            {/* Right side (text) */}
            <div className="col-md-5">
              <div className="about_right">
                <h4 className="line_title">
                  <span></span> About Us
                </h4>
                <h2 className="main_title">
                  Our Journey, Our Vision
                </h2>
                <h6 className="main_desc">
                  {organisationDocument && organisationDocument.aboutUs}
                </h6>
                <div className="bottom">
                  <Link to="" className="theme_btn">Know More</Link>
                  <Link to="" className="call_btn"></Link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BusinessOneBitAbout;
